import styled from 'styled-components';

import colors from '@pickles/shared/utils/colors';
import fonts from '@pickles/shared/utils/fonts';

interface ISelect {
  isSelected?: boolean;
  error?: boolean;
}

export const Select = styled.select<ISelect>`
  width: 100%;
  height: 44px;
  margin-top: 8px;
  padding-left: 22px;
  border-radius: 8px;
  border-width: 1px;
  border-color: ${({ error }) => error ? colors.cerise_red : colors.mischka};
  font-family: ${({ isSelected }) => isSelected ? fonts.BC_MEDIUM_FONT : 'BasierCircle'};
  font-weight: 400;
  font-size: ${({ isSelected }) => isSelected ? '16px' : '15px'};
  color: ${({ isSelected }) => isSelected ? colors.rhino_black : '#8594a9'};
`;